import React from 'react';
import cn from 'classnames';

import Section from 'react-scale/components/elements/section';
import SectionTitle from 'react-scale/components/elements/section-title';
import Image from 'next/image';

type Props = {
  overtitle: string;
  title: string;
  subtitle: string;
  bg: string;
  features: Feature[];
};

type Feature = {
  header: string;
  text: string;
  image: string;
  imageAlt: string;
  imageWidth: string;
  imageHeight: string;
};

export default function FeatureGrid({
  overtitle = 'overtitle',
  title = 'title',
  subtitle = 'subtitle',
  bg = 'bg-black',
  features = []
}: Props) {
  return (
    <Section bg={bg}>
      {/* @ts-ignore */}
      <SectionTitle overtitle={overtitle} title={title} subtitle={subtitle} />
      <ul className="grid gap-y-20 lg:gap-y-32">
        {features.map(feature => (
          <Item
            title={feature.header}
            text={feature.text}
            image={feature.image}
            width={feature.imageWidth}
            height={feature.imageHeight}
            alt={feature.imageAlt}
          />
        ))}
      </ul>
    </Section>
  );
}

type ItemProps = {
  title: string;
  text: string;
  reverse?: boolean;
  image: string;
  width: number;
  height: number;
  alt: string;
};

const Item = ({ title, text, reverse = false, image, width, height, alt }) => (
  <li>
    <article className="grid items-center gap-4 md:grid-cols-2 lg:gap-16">
      <div className={reverse ? 'md:order-2' : 'md:order-1'}>
        <h3 className="mb-4 text-3xl text-white font-aeonik">{title}</h3>
        <p className="text-base md:text-lg lg:text-xl lg:leading-relaxed text-neutral-300">
          {text}
        </p>
      </div>
      <div
        className={cn(
          'relative h-full w-full flex justify-center items-center',
          reverse ? 'md:order-1' : 'md:order-2'
        )}
      >
        <Image src={image} width={width} height={height} alt={alt} />
      </div>
    </article>
  </li>
);
